var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"padding-top":"200px","margin-bottom":"50px","text-align":"center"},attrs:{"id":"welcome"}},[_c('div',{staticStyle:{"display":"table-cell","vertical-align":"middle","text-align":"-webkit-center"}},[_c('div',{staticStyle:{"margin-bottom":"30px"}},[_c('logo')],1),_vm._v(" "),_c('img',{attrs:{"src":"public/images/site/background-welcome-stain.svg","alt":"Arkidia"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54dec5a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/startPage/InicialEmpresas.vue
// module id = 463
// module chunks = 0